export const formatPhoneNumberForDisplay = value => {
  if (value) {
    return value.replace(/^44/, '0');
  }
  return value;
};

export const formatPhoneNumberForAPI = value => {
  if (value) {
    return value.replace(/^0/, '44');
  }
  return value;
};
